import { EpimsBaseEntityDto } from './epim-base.dto';

export class ActivityactionspersonDto extends EpimsBaseEntityDto {
    ActivityActionsPersonId:string;
    StaffId:string;
    PLStageActivityId:string;
    PLRLicenceId:string;

     
    CreatedDate:Date;
    UpdatedDate:Date; 
    Status:string; 
    ActivityName:string;             
    SubscriberId:string;
    PipelineId:string;
    PipelineName:string;
    PipelineLicenceRequestId: string;

    CategoryName:string;
    StageName:string;
    ActivityNo:number;
    BatchId: string;
}
